import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal, Button, message, Tag, notification } from "antd"
import { startCutLaze } from '../../../services/api/3dApi'
import { handleBatchScanSubmit } from '../helper/handleBatchScanSubmit'

const InputCutLaze = () => {

    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [errorInput, setErrorInput] = useState('')
    const [listBatch, setListBatch] = useState([])

    const _onSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        try {
            await handleBatchScanSubmit({
                valueInput,
                listBatch,
                setListBatch,
                setErrorInput,
                maxLimit: 100,
            })
        } catch (error) {
            setErrorInput(error.message || error)
        } finally {
            setLoading(false)
            setValueInput('')
            _input.current.focus()
        }
    }

    const _removeBatch = (batchId) => {
        const newBatchs = listBatch.filter(batch => batch._id !== batchId) || []
        setListBatch(newBatchs)
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
    }

    const _handleStartCutting = async () => {
        setLoading(true)

        try {
            let results = []

            await Promise.all(listBatch.map(async item => {
                const { data: response } = await startCutLaze(item._id, { force_finish: true })

                const { success, error } = Object.assign({}, response)

                if (!success) return results.push({ success: false, batchId: item._id, error, batchName: item.name })
                return results.push({ success: true, batchId: item._id, name: item.name })

            }))

            let newListSuccess = []
            let newListError = []

            results.forEach(result => {
                if (result.success === true) {
                    newListSuccess.push(result.name)
                }

                if (result.success === false) {
                    newListError.push(result)
                }
            })

            if (newListError.length === 0) {
                notification.success({
                    message: `Đánh dấu cắt laze thành công.`,
                })
                setListBatch([])
            } else {
                Modal.info({
                    title: <h4>Kết quả đánh dấu cắt laze</h4>,
                    content: (
                        <div>
                            {newListSuccess.length > 0 && (
                                <div className="mt-2">
                                    <h5 className="text-success">Đánh dấu thành công:</h5>
                                    <ul className="pl-4 list-disc">
                                        {newListSuccess.map(name => (
                                            <li key={name}>{name}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {newListError.length > 0 && (
                                <div className="mt-2">
                                    <h5 className="text-danger">Có lỗi khi đánh dấu các lô:</h5>
                                    <ul className="pl-4 list-disc">
                                        {newListError.map(i => (
                                            <li key={i.batchId}>{`${i.batchName}: ${i.error}`}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    ),
                    okText: 'Đóng',
                    onOk: () => setListBatch([])
                })
            }
            _resetScanInput()

        } catch (error) {
            message.error(error)
        } finally {
            setLoading(false)
        }
    }

    const _handleSubmitCutLaze = () => {
        _handleStartCutting()
    }

    return (
        <div className="UpdateLazeCutting">
            <div className="UpdateLazeCuttingPage">
                <div className="position-relative">
                    <Spin spinning={loading} tip='Đang kiểm tra...'>
                        <form onSubmit={_onSubmit} className="formQC">
                            <Input
                                value={valueInput.toUpperCase()}
                                style={{ fontSize: 40, height: "auto" }}
                                ref={_input}
                                autoFocus={true}
                                placeholder='Nhập vào tên lô'
                                onChange={_handleChangeScan}
                            />

                            {
                                valueInput &&
                                <Icon
                                    type='close-circle'
                                    className="position-absolute cursor-pointer text-dark IconInput"
                                    onClick={_resetScanInput}
                                />
                            }

                            {
                                loading &&
                                <Icon type="sync" spin className="position-absolute IconInput" />
                            }

                            <div className="d-flex justify-content-between align-items-center">
                                <div className="batch_tag">
                                    {
                                        !!listBatch.length &&
                                        listBatch.map((batch) => {
                                            return (
                                                <Tag
                                                    key={batch._id}
                                                    closable
                                                    onClose={() => _removeBatch(batch._id)}
                                                >{batch.name}
                                                </Tag>
                                            )
                                        })
                                    }
                                </div>
                                <div>
                                    {
                                        !loading && !!listBatch.length &&
                                        <Button
                                            type='primary'
                                            className='float-right mt-3 px-4'
                                            onClick={_handleSubmitCutLaze}
                                        >
                                            Cắt Laze
                                        </Button>
                                    }
                                </div>
                            </div>
                        </form>

                        {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                    </Spin>
                </div>
            </div>
        </div>
    )
}

export default InputCutLaze